import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import styled, { keyframes } from 'styled-components';

import { makeImagePreviewable, useLocalizedLogoRibbon } from '../utils';

import Block from './Block';
import Image from './Image';

const slide = (nrOfLogos) => keyframes`
  from {
    transform: translateX(0px);
  }

  to {
    transform: translateX(calc(-60px * ${nrOfLogos} * 2));
  }
`;

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
`;

const AnimationLayer = styled.div`
  display: flex;
  align-items: center;
  animation: ${(props) => slide(props.nrOfLogos)} 70s linear;
  animation-iteration-count: infinite;
`;

const PageLogoRibbon = ({ selectedLocale }) => {
  const [logoRibbon] = useLocalizedLogoRibbon(selectedLocale);

  return (
    <Block backgroundColor="grayLight">
      <Wrapper>
        <AnimationLayer nrOfLogos={logoRibbon.node.data.logos.length}>
          {logoRibbon.node.data.logos.map((item) => {
            const logo = makeImagePreviewable(item.logo);

            return (
              <Block key={`logo-item-${logo.localFile?.id}`} p="baseDown1">
                <Image content={logo} />
              </Block>
            );
          })}

          {logoRibbon.node.data.logos.map((item) => {
            const logo = makeImagePreviewable(item.logo);

            return (
              <Block key={`logo-item-${logo.localFile?.id}-2`} p="baseDown1">
                <Image content={logo} />
              </Block>
            );
          })}
        </AnimationLayer>
      </Wrapper>
    </Block>
  );
};

PageLogoRibbon.propTypes = {
  selectedLocale: PropTypes.string.isRequired,
};

export default PageLogoRibbon;

export const query = graphql`
  fragment LogoRibbonFragment on PrismicLogoRibbon {
    lang
    data {
      logos {
        logo {
          alt
          localFile {
            id
            extension
            childImageSharp {
              gatsbyImageData(
                layout: FIXED
                width: 100
                transformOptions: { grayscale: true }
              )
            }
          }
        }
      }
    }
  }
`;
